//PrintAddressChangeMap.tsx =================================================
import "../Util/Prototypes";

import * as GraLay from "../Util/GraLay";
import * as MainMap from "../MainMap";
import * as PrintAddressChange from "./PrintAddressChange";
import * as PrintAddressChangeMap from "./PrintAddressChangeMap";
import * as PrintAddressChangeUI from "./PrintAddressChangeUI";
import * as Settings from "../Settings";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as SnackBar from "../Util/SnackBar";

import React from "react";
import ReactDOM from "react-dom";

import Extent from "@arcgis/core/geometry/Extent";
import Graphic from "@arcgis/core/Graphic";
import Polyline from "@arcgis/core/geometry/Polyline";
import PrintTemplate from "@arcgis/core/rest/support/PrintTemplate.js";
import PrintParameters from "@arcgis/core/rest/support/PrintParameters.js";
import * as print from "@arcgis/core/rest/print.js";

export let zoomToScale: boolean = false;
export let mapScale: number;
export let mapScaleText: string;
export let imageHeight: string;
export let busy: boolean = false;

let printAreaOutline: __esri.Polyline;
let xMinPrev = "";
let viewWidthPrev = "";

let imageWidth: string;
let map_url: string;

let _mapScaleArray: number[];
let _wdPix: number;
let _htPix: number;
let _wdInch: number;
let _htInch: number;
let _dpi: number;
let _pw: Window;

//Setters.
export function setBusy(busyBee: boolean) {
   busy = busyBee;
}

//Clear this tool.
export function clearTool() {
   GraLay.temp.removeAll();
}

//Compute print sizes and map extent.
export function setPrintParameters(zoomTo: boolean = true) {
   //Util.errMsg("Setting print parameters");

   setPrintSizes();
   setMapExtent(zoomTo);
   setMapScaleText();
}

//Compute print sizes.
function setPrintSizes() {
   let wd: number;
   let ht: number;

   //Overall size of div element to be printed (inches and points).
   wd = 4.3;
   ht = 4.2;

   PrintAddressChange.setPageWidth(inchToPt(wd));
   PrintAddressChange.setPageHeight(inchToPt(ht));

   //Set size variables.
   _wdInch = wd;
   _htInch = ht;

   _dpi = Settings.print.dpi;
   if ((_wdInch * _htInch) > 125) {
      _dpi = 192; //Don't allow high dpi for large prints.
   } else if ((_wdInch * _htInch) > 250) {
      _dpi = 120; //Don't allow high dpi for large prints.
   }

   _wdPix = _wdInch * _dpi;
   _htPix = _htInch * _dpi;

   if (MainMap.activeView.spatialReference) {
      if (MainMap.activeView.spatialReference.isWebMercator) {
         _wdPix *= Settings.mercFactor;
         _htPix *= Settings.mercFactor;
      }
   }

   imageWidth = inchToPt(_wdInch);  //map img element width (points)
   imageHeight = inchToPt(_htInch); //map img element height (points)
}

//Compute map extent.
function setMapExtent(zoomTo: boolean) {
   const activeView = MainMap.activeView as __esri.MapView;
   let mapScaleFeetPerInch: number;

   //Use predefined scale from dropdown list.
   if (PrintAddressChangeUI.isStandardScale) {
      mapScaleFeetPerInch = PrintAddressChangeUI.mapScaleFeetPerInch;
      mapScale = mapScaleFeetPerInch * 12;
      Util.logMsg("Standard mapScale: " + mapScale.toFixed(0) + " mapScaleFeetPerInch: " + mapScaleFeetPerInch.toFixed(0));

   } else { //Initialize scale to current map extent (Default).
      mapScaleFeetPerInch = activeView.scale / 12;
      mapScale = activeView.scale; // Multiply to reduce value to zoom in a bit.
      Util.logMsg("Current mapScale: " + mapScale.toFixed(0) + " mapScaleFeetPerInch: " + mapScaleFeetPerInch.toFixed(0));
   }
   //Util.errMsg("Current map width pix: " + activeView.width.toFixed(0) + " height pix: " + activeView.height.toFixed(0));

   //Set map extent for print page.  The map view extent values honor the left panel padding!
   const dx: number = activeView.extent.xmax - activeView.extent.xmin;
   const dy: number = activeView.extent.ymax - activeView.extent.ymin;

   const xCen: number = (dx / 2) + activeView.extent.xmin; // Map view extent honors the left panel padding!
   const yCen: number = (dy / 2) + activeView.extent.ymin;

   mapScaleFeetPerInch = Util_App.feetToMeters(mapScaleFeetPerInch); //For Mercator.

   let xHalf: number = mapScaleFeetPerInch * ((_wdInch + 0.1) / 2); //Add fudge so print border frame does not print.
   let yHalf: number = mapScaleFeetPerInch * ((_htInch + 0.1) / 2);

   if (activeView.spatialReference && activeView.spatialReference.isWebMercator) {
      xHalf *= Settings.mercFactor;
      yHalf *= Settings.mercFactor;
   }

   let xMin: number = xCen - xHalf;
   let yMin: number = yCen - yHalf;

   let xMax: number = xCen + xHalf;
   let yMax: number = yCen + yHalf;

   let mbr = new Extent({ xmin: xMin, ymin: yMin, xmax: xMax, ymax: yMax, spatialReference: activeView.spatialReference });

   // Process current non-standard scale.
   //if (!PrintAddressChangeUI.isStandardScale) {
   //   //Util.errMsg("View xMin: " + activeView.extent.xmin.toFixed(0) + " yMin: " + activeView.extent.ymin.toFixed(0) + " xMax: " + activeView.extent.xmax.toFixed(0) + " yMax: " + activeView.extent.ymax.toFixed(0));
   //   //Util.errMsg("MBR  xMin: " + xMin.toFixed(0) + " yMin: " + yMin.toFixed(0) + " xMax: " + xMax.toFixed(0) + " yMax: " + yMax.toFixed(0));

   //   const wPrint = xMax - xMin;
   //   const hPrint = yMax - yMin;
   //   const wView = activeView.extent.xmax - activeView.extent.xmin;
   //   const hView = activeView.extent.ymax - activeView.extent.ymin;

   //   const wScaleFactor = wView / wPrint;
   //   const hScaleFactor = hView / hPrint;

   //   const scaleFactor = Math.min(wScaleFactor, hScaleFactor);

   //   const wNew = wPrint * scaleFactor;
   //   const hNew = hPrint * scaleFactor;

   //   xHalf = wNew / 2;
   //   yHalf = hNew / 2;

   //   xMin = xCen - xHalf;
   //   yMin = yCen - yHalf;
   //   xMax = xCen + xHalf;
   //   yMax = yCen + yHalf;

   //   //Util.errMsg("xHalf ft.: " + xHalf.toFixed(0) + " yHalf ft.: " + yHalf.toFixed(0));
   //   //Util.errMsg("xCen: " + xCen.toFixed(0) + " yCen: " + yCen.toFixed(0));
   //   //Util.errMsg("MBR  xMin: " + xMin.toFixed(0) + " yMin: " + yMin.toFixed(0) + " xMax: " + xMax.toFixed(0) + " yMax: " + yMax.toFixed(0));

   //   mbr = new Extent({ xmin: xMin, ymin: yMin, xmax: xMax, ymax: yMax, spatialReference: activeView.spatialReference });
   //}

   //Create print area graphic.
   const paths = [[[xMin, yMin], [xMin, yMax], [xMax, yMax], [xMax, yMin], [xMin, yMin]]];
   printAreaOutline = new Polyline({ hasZ: false, hasM: false, paths: paths, spatialReference: activeView.spatialReference });

   //Rotate the print graphic back to zero degrees.
   if (MainMap.mapView.rotation !== 0 && Util_App.geometryEngine) {
      printAreaOutline = Util_App.geometryEngine.rotate(printAreaOutline, MainMap.mapView.rotation) as __esri.Polyline;
   }

   //Set symbology.
   const sym = { type: "simple-line", color: [255, 200, 30, 0.7], width: 5 };
   const gra = new Graphic({ geometry: printAreaOutline, symbol: sym });

   GraLay.temp.removeAll();

   if (MainMap.view2D) {
      GraLay.temp.add(gra);
   }

   //Zoom to print extent when map scale dropdown changed.
   if (zoomTo && PrintAddressChangeUI.isStandardScale) {
      zoomTo = false;

      if (mbr.extent.xmin.toFixed(0) !== xMinPrev || activeView.width.toFixed(0) !== viewWidthPrev) {
         xMinPrev = mbr.extent.xmin.toFixed(0);
         viewWidthPrev = activeView.width.toFixed(0);

         //Util.errMsg("Zooming to mbr");
         activeView.goTo(mbr, Settings.animateOptions);
      }
   }
}

//Get URL of map image to be printed.
export function getMapURL(): void {

   if (MainMap.view2D) { // 2D
      buildPrintImage();

   } else { // 3D screenshot.
      Util.errMsg("Error creating map image");
   }
}

//Compute map scale text.
function setMapScaleText() {
   let scale: number = mapScale / 12;
   let scaleTxt: string = scale.toFixed();
   let units: string = "feet";

   if (scale >= 2640) {
      scale = scale / 5280;
      scaleTxt = scale.toFixed(1);
      units = "miles";
      if (scale <= 1) {
         units = "mile";
      }
   }

   return mapScaleText = "1 inch = " + scaleTxt + " " + units;
}

function getPrintDate() {
   let curDate: string = (new Date()).ToShortDate();
   return "Form printed: " + curDate;
}

function getNewAddress() {
   let newAddressStr: string = (PrintAddressChangeUI.newStreetText === undefined) ? '' : PrintAddressChangeUI.newStreetText;
   let line1: string = '';
   let line2: string = '';
   let line3: string = '';
   let line4: string = '';
   let line5: string = '';
   let lineNumber = 1;
   while (newAddressStr.length > 0) {
      let pattern: RegExp = new RegExp(/([a-zA-Z0-9])/);
      let addbind: string = "";
      if (pattern.test(newAddressStr.substr(36, 1)) && pattern.test(newAddressStr.substr(36 - 1, 1))) addbind = "-";
      if (lineNumber === 1) { line1 = newAddressStr.substring(0, 36) + addbind; }
      else if (lineNumber === 2) { line2 = newAddressStr.substring(0, 36) + addbind; }
      else if (lineNumber === 3) { line3 = newAddressStr.substring(0, 36) + addbind; }
      else if (lineNumber === 4) { line4 = newAddressStr.substring(0, 36) + addbind; }
      else if (lineNumber === 5) { line5 = newAddressStr.substring(0, 36) + addbind; }
      newAddressStr = newAddressStr.substring(36);
      lineNumber += 1;
   }
   return [line1, line2, line3, line4, line5];
}

//Build the image to be printed.
function buildPrintImage() {
   Spinner.show();
   busy = true;

   let printDate: string = getPrintDate();
   let newAddressLines: string[] = getNewAddress();
   //Util.logMsg("newAddressLines:", newAddressLines);
   let newAddressLine1: string = newAddressLines[0];
   let newAddressLine2: string = newAddressLines[1];
   let newAddressLine3: string = newAddressLines[2];
   let newAddressLine4: string = newAddressLines[3];
   let newAddressLine5: string = newAddressLines[4];

   const template = new PrintTemplate({
      format: "pdf",
      exportOptions: {
         width: _wdPix,
         height: _htPix,
         dpi: _dpi,
      },
      layout: "Address_Change_Letter_Portrait",
      scalePreserved: true,
      outScale: mapScale,
      layoutOptions: {
         customTextElements: [
            { owner: (PrintAddressChangeUI.ownerText === undefined) ? '' : PrintAddressChangeUI.ownerText },
            { address: (PrintAddressChangeUI.ownerAddressText === undefined) ? '' : PrintAddressChangeUI.ownerAddressText },
            { date: (PrintAddressChangeUI.approvalDateText === undefined) ? '' : PrintAddressChangeUI.approvalDateText },
            { oldAddress: (PrintAddressChangeUI.oldStreetText === undefined) ? '' : PrintAddressChangeUI.oldStreetText },
            { newAddress: newAddressLine1 },
            { newAddressLine2: newAddressLine2 },
            { newAddressLine3: newAddressLine3 },
            { newAddressLine4: newAddressLine4 },
            { newAddressLine5: newAddressLine5 },
            { thomasBrothers: (PrintAddressChangeUI.thomasBrothersText === undefined) ? '' : PrintAddressChangeUI.thomasBrothersText },
            { map: (PrintAddressChangeUI.mapNoText === undefined) ? '' : PrintAddressChangeUI.mapNoText },
            { project: (PrintAddressChangeUI.projectNoText === undefined) ? '' : PrintAddressChangeUI.projectNoText },
            { apn: (PrintAddressChangeUI.apnText === undefined) ? '' : PrintAddressChangeUI.apnText },
            { scaleText: (PrintAddressChangeUI.scaleText === undefined) ? '' : setMapScaleText() },
            { printDate: printDate }
         ]
      }
   });

   const params = new PrintParameters({
      view: MainMap.mapView,
      template: template,
      outSpatialReference: MainMap.activeView.spatialReference,
   });

   Util.logMsg("params:", params);

   const printTaskUrl = Settings.printService_URL;

   //Util.logMsg("Params: ", params);
   //Util.logMsg("MapView: ", MainMap.mapView);
   print.execute(printTaskUrl, params).then(printResult).catch(printError);
}

function printResult(results) {
   Util.logMsg("results.url: ", results.url);
   Spinner.hide();
   busy = false;
   /*PrintAddressChangeUI.newWindow.location = results.url;*/
   window.open(results.url);
}

//Print task failed.
function printError(err) {
   Spinner.hide();
   busy = false;
   SnackBar.show("Error creating map image", 3);
   Util.errMsg("Error creating map image", err);
}

//Create array of map scales.
function createMapScaleArray() {
   let i: number;
   let sa: string[];
   let scaleVal: number;

   _mapScaleArray = [];

   for (i = 2; i < Settings.print.scales.length; i++) {
      sa = Settings.print.scales[i].split("=");

      scaleVal = Util.parseFlt(sa[1]);
      if (sa[1].Contains("ile")) {
         scaleVal *= 5280;
      }
      _mapScaleArray.Add(scaleVal);
   }
}

//Inch to point.
function inchToPt(inch: number): string {
   return (inch * 72) + "pt";
}

//Image loaded event.
function imageLoaded() {
   Spinner.hide();
   busy = false;

   if (navigator.userAgent.indexOf("Firefox") > 0) {
      Util_App.openPrintWindow("Print Map", "PrintMap");

   } else {
      window.print(); // for Chrome, Edge, etc.
   }

   //To Debug: Comment below line out and set print_div visibility to "visible" in index.html.
   ReactDOM.render(<div />, document.getElementById("print_div")); //Clear the print div.
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   return (
      <img src={map_url} onLoad={imageLoaded} alt="Map" style={{ width: imageWidth, height: PrintAddressChangeMap.imageHeight, border: "2px solid gray", margin: 0, padding: 0 }} />
   );

} //end function.
